import { initPhoneReveal } from '@helpers/phoneReveal';

initPhoneReveal();

export { initPhoneReveal };
